const fallBackStore = {};

function setOnStore(key, value) {
  // fallBackStore[key] = value;

  try {
    // eslint-disable-next-line no-undef
    localStorage?.setItem(key, value);
  } catch (error) {
    fallBackStore[key] = value;
  }
}

function getFromStore(key) {
  // return fallBackStore[key];

  try {
    // eslint-disable-next-line no-undef
    return localStorage?.getItem(key);
  } catch (error) {
    return fallBackStore[key];
  }
}

function removeFromStore(key) {
  // delete fallBackStore[key];

  try {
    // eslint-disable-next-line no-undef
    localStorage?.removeItem(key);
  } catch (error) {
    delete fallBackStore[key];
  }
}

export { getFromStore, removeFromStore, setOnStore };
